import React from 'react';
import classnames from 'classnames';
import { Link } from 'react-router-dom';
import GlobalProps from '../globalProps';

export interface TabProps extends GlobalProps {
  title: string;
  active?: boolean;
  disabled?: boolean;
  useNavigation?: boolean;
  path?: string;
  onClick?: () => void;
}

export function Tab({ title, active, disabled, className, style, onClick }: TabProps): JSX.Element {
  return (
    <div
      className={classnames('tabs__tab', className, {
        'tabs__tab--active': active,
        'tabs__tab--disabled': disabled,
      })}
      tabIndex={disabled ? -1 : 0}
      style={style}
      onClick={onClick}
    >
      {title}
    </div>
  );
}

export function TabLink({ title, path, active, disabled, className, style }: TabProps): JSX.Element {
  return (
    <Link
      className={classnames('tabs__tab', className, {
        'tabs__tab--active': active,
        'tabs__tab--disabled': disabled,
      })}
      tabIndex={disabled ? -1 : 0}
      to={path || ''}
      style={style}
    >
      {title}
    </Link>
  );
}
